
import Button from '@/components/elements/Button';

export default {
  name: 'ScrollUpBtn',
  components: {
    Button,
  },
  data() {
    return {
      canShowBtn: false,
      timer: 0,
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      const currentPageScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentPageScroll > window.innerHeight) {
        this.canShowBtn = true
      } else {
        this.canShowBtn = false
      }
    }, 100);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
